<template>
  <section class="portfolio" id="portfolio">
			<div class="container">
				<div class="protfolio__upper">
          <div class="section-title">
              <h2>Portfolio</h2>
              <p>Examples of my latest projects build with HTML, CSS and JavaScript. <br> My portfolio includes worpdress websites, web applications and some design made with figma and adobe photshop</p>
          </div>
        </div>
        <div class="portfolio__bottom">
          <div class="portfolio__bottom__filter">
            <div class="filter__heading">
              <ul>
                <li class="btn btn1 list active" data-filter="all">All</li>
                <li class="btn btn1 list" data-filter="wordpress">Wordpress</li>
                <li class="btn btn1 list" data-filter="front">Front end</li>
                <li class="btn btn1 list" data-filter="design">Design</li>
              </ul>
            </div>
          </div>
          <div class="portfolio__bottom__content">
            <ul class="content__items row">
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/capi.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Capi</h1>
                    <ul class="project-tech-list">
                      <li>WordPress</li>
                      <li>PHP</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://capi-agglo.fr/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/hairstetics.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Hairstetics</h1>
                    <ul class="project-tech-list">
                      <li>WordPress</li>
                      <li>PHP</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://hairstetics.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/najen.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Najen nature</h1>
                    <ul class="project-tech-list">
                      <li>Prestashop</li>
                      <li>scss</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://najen-nature.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/valrhona.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Valrhona</h1>
                    <ul class="project-tech-list">
                      <li>Magento</li>
                      <li>scss</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://www.valrhona.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/redlean.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Readlean</h1>
                    <ul class="project-tech-list">
                      <li>Wordpress</li>
                      <li>scss</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://redlean.io/en/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/sge.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>SGE & IEG</h1>
                    <ul class="project-tech-list">
                      <li>Wordpress</li>
                      <li>scss</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://sgeieg.fr/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/techviz.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Techviz</h1>
                    <ul class="project-tech-list">
                      <li>Wordpress</li>
                      <li>php</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://www.techviz.net/en/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/gostaffsite.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Gostaff</h1>
                    <ul class="project-tech-list">
                      <li>Wordpress</li>
                      <li>php</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://gostaff.io/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/entrechasseur.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Entre chasseur</h1>
                    <ul class="project-tech-list">
                      <li>Magento</li>
                      <li>scss</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://www.entrechasseurs.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/hockey.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>SOC Hockey</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>css</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="https://www.hockey-chambery.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/kalima.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Kalima editios</h1>
                    <ul class="project-tech-list">
                      <li>html</li>
                      <li>css</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="http://www.kalima-edition.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="front">
                <div class="list__img">
                  <img src="../../assets/eseac.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>ESEAC</h1>
                    <ul class="project-tech-list">
                      <li>Drupal</li>
                      <li>css</li>
                      <li>Javascript</li>
                    </ul>
                    <a href="http://www.eseac.ens.tn/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/jardain.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Compostage au jardin</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>figma</li>
                    </ul>
                    <a href="https://www.compostage-au-jardin.org/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/rgpd.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>rgpd avocat</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>figma</li>
                    </ul>
                    <a href="https://www.rgpd-avocat.net/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/cuisine.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Au sesame</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>figma</li>
                    </ul>
                    <a href="https://www.au-sesame.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/pimenteo.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>pimenteo</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>figma</li>
                    </ul>
                    <a href="https://www.pimenteo.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img">
                  <img src="../../assets/gsdeppanage.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Gs deppanage</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                      <li>figma</li>
                    </ul>
                    <a href="https://gsdepannage.ch/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/adomik.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Adomik</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                    </ul>
                    <a href="https://www.adomik.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/bayti.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Bayti</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                    </ul>
                    <a href="https://bayti-property.com/" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              
              <li class="itemBox content__items__list col-4" data-item="wordpress">
                <div class="list__img">
                  <img src="../../assets/raf.jpg">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>Raf 73</h1>
                    <ul class="project-tech-list">
                      <li>wordpress</li>
                    </ul>
                    <a href="#" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              
            </ul>
            <!--
            <ul class="content__items row" v-if="list.length">
              <li class="itemBox content__items__list col-4" data-item="wordpress" v-for="item in list" :key="item.id">
                <div class="list__img" v-if="item.acf.image.url!=null">
                  <img :src="item.acf.image.url" alt="">
                </div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>{{item.title.rendered}}</h1>
                    <ul class="project-tech-list">
                      <li>Algolia</li>
                      <li>WordPress</li>
                      <li>PHP</li>
                    </ul>
                    <a :href="item.acf.link" class="anim-09">See project</a>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img"><img src="../../assets/capi.jpg" alt=""></div>
                <div class="list__overlay">
                  <div class="overlay__content">
                    <h1>title</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id bibendum velit</p>
                  </div>
                </div>
              </li>
              <li class="itemBox content__items__list col-4" data-item="design">
                <div class="list__img"><img src="../../assets/capi.jpg" alt=""></div>
                <div class="list__links"></div>
              </li>
            </ul>
            -->
          </div>
        </div>
      </div>
		</section>
</template>

<style lang="scss">
@import '@/scss/portfolio.scss';
@import '@/scss/global.scss';
</style>

<script>
import axios from 'axios';


export default {
  name: "portfolio-home",

  data(){
    return {list:[]};
    
  },
  created(){
    axios.get('http://wp-admin.test/wp-json/wp/v2/portfolio').then(resp=>{
      console.log(resp);

      this.list=resp.data;
      console.log(this.list)
    })
  },
  mounted(){
    let list = document.querySelectorAll('.list');
    let itemBox = document.querySelectorAll('.itemBox');

    for(let i = 0; i<list.length; i++){
        list[i].addEventListener('click', function(){
            for(let j = 0; j<list.length; j++){
                list[j].classList.remove('active');
            }
            this.classList.add('active');

            let dataFilter = this.getAttribute('data-filter');

            for(let k = 0; k<itemBox.length; k++){
                itemBox[k].classList.remove('active');
                itemBox[k].classList.add('hide');
            
            if(itemBox[k].getAttribute('data-item') == dataFilter || dataFilter == "all"){
                itemBox[k].classList.remove('hide');
                itemBox[k].classList.add('active');
            }
        }
        })
    }
  }

};

</script>
